import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useRef, useState } from "react";
import { AnchoredOrderMenu } from "./anchored-order-menu";
import { NavLink } from "react-router-dom";
import "./mobile-order-actions.scss";

export type OrderAction = { id: string; label: string; icon: string; onSelect?: () => unknown; to?: string; href?: string; disabled?: boolean };

export default function MobileOrderActions({ label, actions, rtl }: { label: string; actions: OrderAction[]; rtl: boolean }) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);
  const [openedActions, setOpenedActions] = useState(actions);
  const { t } = useTranslation("myOrder");
  const busy = useRef(false);
  const trigger = useRef<HTMLButtonElement>(null);
  const invoked = useRef(false);
  const close = () => setOpen(false);
  return <>
    <button ref={trigger} type="button" className="mobile-order-actions-trigger" aria-label={label} aria-haspopup="menu" aria-expanded={open} aria-busy={pending} disabled={pending}
      onClick={event => { event.stopPropagation(); if (busy.current) return; invoked.current = false; setOpenedActions(actions); setOpen(!open); }}>{pending ? "…" : "•••"}</button>
    {open && <AnchoredOrderMenu anchor={trigger.current} rtl={rtl} label={label} onClose={close}>
        {openedActions.map(action => {
          const content = <><img src={action.icon} alt="" /><span>{action.label}</span></>;
          const activate = (event: any) => {
            event.stopPropagation();
            if (invoked.current || busy.current || action.disabled) { event.preventDefault(); return; }
            invoked.current = true;
            try {
              // Capture/invoke the opened order's callback before unmounting its menu.
              const result = action.onSelect?.();
              close();
              if (result && typeof (result as Promise<unknown>).then === "function") {
                busy.current = true; setPending(true);
                Promise.resolve(result).catch(() => toast.error(t("action failed")))
                  .finally(() => { busy.current = false; setPending(false); });
              }
            } catch {
              invoked.current = false; event.preventDefault(); toast.error(t("action failed"));
            }
          };
          if (action.to) return <NavLink key={action.id} role="menuitem" aria-disabled={action.disabled || undefined} to={action.to} onClick={activate}>{content}</NavLink>;
          if (action.href) return <a key={action.id} role="menuitem" aria-disabled={action.disabled || undefined} href={action.href} target="_blank" rel="noopener noreferrer" onClick={activate}>{content}</a>;
          return <button key={action.id} type="button" role="menuitem" data-danger={action.id === "delete" || undefined} disabled={action.disabled} onClick={activate}>{content}</button>;
        })}
    </AnchoredOrderMenu>}
  </>;
}
